import { useCallback } from 'react'
import type { JSX } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { Text, UnstyledButton } from '@buffer-mono/popcorn'

import {
  parseQueryParams,
  serializeQueryParams,
} from '~publish/hooks/useQueryParam'

import styles from './QueueSlot.module.css'

type OccupiedQueueSlotProps = {
  date: string
}

export const OccupiedQueueSlot = ({
  date,
}: OccupiedQueueSlotProps): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()

  // Clears the tag and post type filters in one navigation. Either can be what
  // hid this post, and two `useQueryParam` setters cannot do it: each closes
  // over the query it parsed at render time, so the second rebuilds the search
  // string from a snapshot still holding the key the first removed.
  const onRemoveFilterClick = useCallback(() => {
    const search = serializeQueryParams({
      ...parseQueryParams(location.search),
      tags: undefined,
      postTypes: undefined,
    })
    navigate({ ...location, search })
  }, [location, navigate])

  return (
    <div
      className={clsx(styles.slot, styles.occupied)}
      data-datetime={date}
      data-testid="occupied-queue-slot"
    >
      <Text className={styles.occupied}>
        Post hidden by filters.{' '}
        <UnstyledButton
          className={styles.clearFiltersButton}
          onClick={onRemoveFilterClick}
        >
          Clear filters
        </UnstyledButton>
      </Text>
    </div>
  )
}

OccupiedQueueSlot.displayName = 'OccupiedQueueSlot'
